var $name="shell/registry/PartialUnit",$path="app/modules/shell/registry/PartialUnit.js",$this={$name,$path,};import PartialContext from './PartialContext';
import VisualUnit from './VisualUnit';

export default class Partial extends VisualUnit {
  constructor(source, callback) {
    super(source, callback);
    super.createContext(PartialContext, this);
  }
}
